import { posts } from "assets/data/posts";
import { FeedPost, ThreadPost } from "components";
import { useParams, useNavigate } from "react-router-dom";
import Breadcrumb, { BreadcrumbObject } from "ui/files/core/Breadcrumb";
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";

const PostPage = () => {
    const params = useParams();
    const navigate = useNavigate();
    console.log("params: ", params.id);

    const breadcrumb: BreadcrumbObject[] = [
        {
            path: "/",
            text: "Main"
        }
    ];

    return (
        <section className="w-full h-full flex flex-col relative">
            <div className="w-full h-full flex relative  overflow-auto">
                <div className="w-full flex flex-col px-10 py-2">
                    <div className="flex justify-between items-center w-full text-center">
                        <button onClick={() => navigate(-1)}>
                            <ArrowBackIosNewRoundedIcon
                                fontSize="small"
                                className="dark:text-white"
                            />
                        </button>
                        <Breadcrumb
                            breadcrumb={breadcrumb}
                            currentPath="View Post"
                        />
                    </div>
                    <div className="w-full items-center flex flex-col gap-10 px-10 ">
                        <div className="card thread-post">
                            <FeedPost post={posts[0]} showLink={false} />
                        </div>
                        <ThreadPost
                            post={posts[5]}
                            threads={posts}
                            showThreads
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default PostPage;
